<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <!-- Title page  -->
            <h1 class="page__title">{{ $t(titlePage) }}</h1>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <!-- Filter -->
                <CRow class="justify-content-end p-2 m-0">
                    <CCol md="5">
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <!-- Button back -->
                                <ButtonBack class="mr-3" title="Go back" />
                            </CCardHeader>
                            <CCardBody>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.steps.items"
                                    :fields="traslateLabels(tables.steps.fields)"
                                    :columnFilterValue.sync="
                                        tables.steps.columnFilterValue
                                    "
                                    :sorterValue.sync="tables.steps.sorterValue"
                                    @update:column-filter-value="updateData()"
                                    @update:sorter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :items-per-page="tables.steps.rows"
                                    v-bind="tables.steps"
                                >
                                    <template #order_step="{item}">
                                        <td class="py-2">
                                            Step {{item.order_step}}
                                        </td>
                                    </template>
                                    <template #options="{item}">
                                        <td class="py-2">
                                            <CButton
                                                color="primary"
                                                variant="outline"
                                                square
                                                size="sm"
                                                @click="downloadStep(item)"
                                            >
                                                <CIcon class="icon" :content="$options.icons.cilDataTransferDown"/>
                                            </CButton>
                                        </td>
                                    </template>
                                </CDataTable>
                                
                            </CCardBody>
                            <CCardFooter>
                                <CPagination
                                    @update:activePage="updatePagination"
                                    :activePage="tables.steps.page"
                                    :pages="tables.steps.total_pages"
                                    align="center"
                                />
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/**
 * Components
 */
import FilterDate from "~/components/FilterDate";
import ButtonBack from "£lement/ButtonBack";

/**
 * Mixins
 */
import pageMixin from "~/mixins/page";
import tableMixin from "~/mixins/table";

/**
 * Others
 */
import { cilPlus, cilSettings, cilPencil, cilDataTransferDown,cilMediaPlay, cilWarning, cilArrowThickFromRight } from '@coreui/icons';


export default {
    name:"StepsPage",
    middleware: ["auth","page"],
    components:{
        FilterDate,
        ButtonBack
    },
    icons:{
        cilPlus,
        cilSettings,
        cilPencil,
        cilDataTransferDown,
        cilMediaPlay,
        cilWarning,
        cilArrowThickFromRight
    },
    mixins: [ pageMixin, tableMixin ],
    data(){
        return{
            tables:{
                steps:{
                    fields: [
                        {
                            key: "id",
                            label:"#",
                            sorter: false,
                            filter: false,
                        },
                        {
                            key: "order_step",
                            label:"step_number",
                            sorter: false,
                            filter: false,
                        },
                        {
                            key: "options",
                            label:"options",
                            sorter: false,
                            filter: false,
                        },
                    ],
                    allFields: [],
                    items: [],
                    order: "desc",
                    page: 1,
                    rows: 10,
                    total_pages: 1,
                    loading: true,
                    pagination: true,
                    columnFilter: {
                        external: true,
                        lazy: true,
                    },
                    columnFilterValue: {},
                    itemsPerPageSelect: true,
                    itemSelected: null,
                    sorter: {
                        external: true,
                        resetable: true,
                    },
                    sorterValue: {
                        column: "order_step",
                        asc: true,
                    },
                }
            },
            messages:{
                delete:{
                    header:"form",
                    body:"form deleted", 
                },
                error:{
                    header:'error!',
                    body:"there_was_a_problem",
                    color:'danger',
                    outline:true
                }
            }
        }
    },
    computed:{
        uuid : function(){
            return this.$route.query.form_id;
        }
    }, 
    methods:{
        async updateData() {

            await this.updateTable({
                tableName: "steps",
                url: `/forms.api/${this.uuid}/steps`,
            });
            this.tables.steps.itemSelected = null;
            this.updatePageLoading(false);

        },

        getBlobURL(code, type){
            const blob = new Blob([code], { type });
            return URL.createObjectURL(blob);
        },
        async downloadStep(item){
            let form_id = this.$route.query.form_id;
            let order_step = item.order_step;
            let stepContent = await this.fetcher(
                {
                    url: `forms.api/${form_id}/steps/${order_step}`,
                }
            )
            let downloadLink = this.getBlobURL(stepContent.html,"text/html");
            let elementLink = document.createElement('a');
            elementLink.setAttribute('href',downloadLink);
            if(item.order_step == 0){
                elementLink.setAttribute('download',`index.html`);
            }else{
                elementLink.setAttribute('download',`step${item.order_step}`);
            }
            elementLink.click();
        }
    },
    mounted(){
        this.updateData();
    }
}
</script>

<style scoped lang="scss">
    
</style>